<template>
  <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
    <el-row :gutter="20">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :lg="{ span: 24 }"
      >
        <el-form-item
          :label="$l('form_label_attribute_type') || '属性类型'"
          prop="resAttributeType"
        >
          <el-input
            v-model="formData.resAttributeType"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :lg="{ span: 24 }"
      >
        <el-form-item
          :label="$l('form_label_name_cn') || '中文名称'"
          prop="resAttributeTypeName"
        >
          <el-input
            v-model="formData.resAttributeTypeName"
            clearable
            size="medium"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :lg="{ span: 24 }"
      >
        <el-form-item
          :label="$l('form_label_name_en') || '英文名称'"
          prop="resAttributeTypeNameEn"
        >
          <el-input
            v-model="formData.resAttributeTypeNameEn"
            clearable
            size="medium"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";

export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    resAttributeTypeCode: String,
  },
  data() {
    return {
      formData: {
        resAttributeTypeCode: "",
        resAttributeType: "",
        resAttributeStatus: "Y",
        resAttributeTypeName: "",
        resAttributeTypeNameEn: "",
      },
      rules: {
        resAttributeType: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_type") || "请输入属性类型",
            trigger: "blur",
          },
        ],
        resAttributeTypeName: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name") || "请输入中文名称",
            trigger: "blur",
          },
        ],
        resAttributeTypeNameEn: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name_en") ||
              "请输入英文名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    // getData() {
    //   if (!this.resAttributeTypeCode) return;

    //   this.$api
    //     .detailResearchDictionaryTypeApi({
    //       resAttributeTypeCode: this.resAttributeTypeCode,
    //     })
    //     .then((res) => {
    //       this.formData = res.body;
    //     });
    // },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        return;
      }
      this.loadingOpen();
      this.$api
        .saveResearchDictionaryTypeApi(this.formData)
        .then((res) => {
          this.loadingClose();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.openQuestion();
    },
    close() {
      this.$emit("close");
    },
    openQuestion() {
      this.$confirm(
        this.$l("INDEX.tips_question_save") || "是否要保存更改",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l("INDEX.btn_save") || "保存",
          cancelButtonText: this.$l("INDEX.btn_no_save") || "不保存",
        }
      )
        .then(() => {
          this.save();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
  },
};
</script>
